import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DpSpReceivingService } from '../services/raintree/Transmission/dp-sp-receiving.service';
import { ToastrService } from 'ngx-toastr';
import { DpLoaderComponent } from '../common-component/dp-loader/dp-loader.component';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'receiving-detailed-report',
  standalone: true,
  imports: [
    CommonModule,
    DpLoaderComponent
  ],
  templateUrl: './receiving-detailed-report.html',
  styleUrl: './dp-sp-receiving-report.component.scss'
})
export class ReceivingDetailedReportDialogComponent implements OnInit {
  isLoad!: boolean
  detailedReport: any
  constructor(
    private _receivingS: DpSpReceivingService,
    private toaster: ToastrService,
    private detailedReportDialogRef: MatDialogRef<ReceivingDetailedReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userId: string, startDate: string, endDate: string, userName: string }
  ) { }

  ngOnInit(): void {
    console.log(this.data)
    this.isLoad = true;
    this._receivingS.getReceivingReport(this.data.userId, this.data.startDate, this.data.endDate).subscribe({
      next: (response: any) => {
        if (!response.error) {
          this.isLoad = false;
          console.log(response.data);
          this.detailedReport = response.data
        }
      },
      error: error => {
        this.toaster.clear();
        this.toaster.error(error);
      }
    })
  }

  closeDialog(): void {
    this.detailedReportDialogRef.close(); // Close the dialog
  }
}



@Component({
  selector: 'app-dp-sp-receiving-report',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DpLoaderComponent,
  ],
  templateUrl: './dp-sp-receiving-report.component.html',
  styleUrl: './dp-sp-receiving-report.component.scss'
})
export class DpSpReceivingReportComponent {
  constructor(
    private _receivingS: DpSpReceivingService,
    private toaster: ToastrService,
    private dialogS: MatDialog,
  ) { }

  public isLoader !: boolean;
  public reportData: any = '';
  public sDate !: string;
  public eDate !: string;
  public maxDate: string = new Date().toISOString().split('T')[0];
  public dateForm: FormGroup = new FormGroup({
    startDate: new FormControl(""),
    endDate: new FormControl("")
  });

  onSubmitDate = () => {
    this.isLoader = true;
    console.log(this.dateForm.value)

    let [sY, sM, sD] = this.dateForm.value.startDate.split('-');
    let [eY, eM, eD] = this.dateForm.value.endDate.split('-');

    this.sDate = `${sD}-${sM}-${sY}`
    this.eDate = `${eD}-${eM}-${eY}`

    this._receivingS.getReceivingReport('', this.sDate, this.eDate).subscribe({
      next: (response: any) => {
        if (!response.error) {
          this.isLoader = false;
          this.reportData = response.data;
        }
      },
      error: error => {
        this.toaster.clear();
        this.toaster.error(error);
      }
    })

  }

  onClickLotReport = (userDetails: any) => {
    console.log(userDetails);
    let userId = userDetails.receivedUserId;
    let userName = userDetails.receivedUserName;
    const dialogRef = this.dialogS.open(ReceivingDetailedReportDialogComponent, {
      data: { userId: userId, startDate: this.sDate, endDate: this.eDate, userName: userName }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('dialog result', result);
    })
  }
}